<template>
  <div class="pos-refund-container pos_refund_fullscreen">
    <div class="pos-refund-wrapper">
      <header>{{ $tc("refund", 1) }} {{ $tc("ticket", 1) }}</header>
      <button @click="callClose()" class="btn-modal-close">&times;</button>

      <!-- SECTION 1 -->
      <div class="refund-center-content" v-if="section.one">
        <div class="col-lg-6 col-xl-4 mx-auto text-center mb-5">
          <div class="input-material mb-4">
            <input
              v-model="booking_id"
              type="text"
              id="refundbookingCode"
              required="required"
              placeholder="Ticket No."
            />
            <label>{{ $tc("ticket", 1) }} {{ $t("no") }}</label>
            <VkeyboardFloat
              :ID="'refundbookingCode'"
              :onClickFun="
                () => {
                  keyboardsVisible.showV1Keyboard = !keyboardsVisible.showV1Keyboard;
                }
              "
            />
            <Vkeyboard
              :inputName="'refundbookingCode'"
              :showOrHide="keyboardsVisible.showV1Keyboard"
              :initialValue="booking_id"
              @onChangeEvent="() => {}"
              @onKeyEnter="show2"
              @changeKeyboardInput="booking_id = $event"
              @onClickClose="
                () => {
                  keyboardsVisible.showV1Keyboard = false;
                }
              "
            />
          </div>

          <button v-on:click="show2()" class="btn-blue-lg">
            {{ $t("submit") }}
          </button>
        </div>
      </div>

      <!-- SECTION 2  -->
      <div class="content-fnb-refund" v-if="section.two">
        <div class="col-lg-8 col-xl-6 mx-auto mb-5">
          <div class="row">
            <div class="col-6 mb-4">
              <div class="input-material">
                <input
                  type="text"
                  :disabled="true"
                  :value="booking_id"
                  required="required"
                />
                <label>{{ $tc("ticket", 1) }} {{ $t("no") }}</label>
              </div>
            </div>
            <div class="col-6 mb-4">
              <div class="input-material">
                <div class="dropdown-curve-container">
                  <label :class="RefundReason.length > 0 ? 'shift-up' : ''"
                    >{{ $t("select") }} {{ $tc("refund", 2) }}
                    {{ $tc("reason", 2) }}</label
                  >
                  <div class="d-flex justify-content-center align-items-center">
                    <b-dropdown
                      :text="RefundReason"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        href="#"
                        v-for="(item, itemIndex) in Refunds"
                        :key="itemIndex"
                        v-on:click="onSelectHandler(item)"
                        >{{ item.rr_reason }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <!-- <Tooltip :title="$t('vendorsCountry_tooltip')" />-->
                  </div>
                </div>
                <!-- <input type="text" :value="refund.rr_reason" required="required" disabled />
                <label>Ticket Refund Reason</label>-->
              </div>
            </div>

            <div class="col-6 mb-4">
              <div class="dropdown-curve-container">
                <label :class="selectedPaymentObj ? 'shift-up' : ''"
                  >{{ $t("select") }} {{ $tc("refund", 2) }}
                  {{ $tc("mode", 2) }}</label
                >
                <multiselect
                  v-model="selectedPaymentObj"
                  @select="onSelectHandlerPayment($event)"
                  @remove="onRemovePaymentMode($event)"
                  placeholder=""
                  track-by="pm_id"
                  label="pm_payment_mode"
                  :options="paymentModes"
                  :multiple="false"
                >
                </multiselect>
              </div>
            </div>

            <div class="col-6 mb-4">
              <div class="dropdown-curve-container">
                <label
                  v-if="Selectedseats && Selectedseats.length > 0"
                  :class="
                    Selectedseats && Selectedseats.length > 0 ? 'shift-up' : ''
                  "
                  >{{ $t("select") }} {{ $tc("seats", 2) }}</label
                >
                <multiselect
                  disabled
                  v-if="isPrivateShow"
                  v-model="Selectedseats"
                  @select="onSelectSeats($event)"
                  @remove="onRemoveSeats($event)"
                  placeholder="Select Seats"
                  track-by="sl_id"
                  label="sl_seat_name"
                  :options="seats"
                  :multiple="true"
                >
                  <template slot="option" slot-scope="props"
                    ><span>{{
                      props.option.mycinema_booking_type_id &&
                      props.option.mycinema_booking_type_id == 3
                        ? "Entire Show"
                        : props.option.sl_seat_name
                    }}</span>
                  </template>
                  <template slot="tag" slot-scope="props">
                    <span class="multiselect__tag">
                      <span>{{
                        props.option.mycinema_booking_type_id &&
                        props.option.mycinema_booking_type_id == 3
                          ? "Entire Show"
                          : props.option.sl_seat_name
                      }}</span>
                    </span>
                  </template>
                </multiselect>
                <multiselect
                  v-else
                  v-model="Selectedseats"
                  disabled
                  @select="onSelectSeats($event)"
                  @remove="onRemoveSeats($event)"
                  placeholder="Select Seats"
                  track-by="sl_id"
                  label="sl_seat_name"
                  :options="seatsArr"
                  :multiple="true"
                  group-values="SeatsArray"
                  group-label="label"
                  :group-select="true"
                >
                </multiselect>
              </div>
            </div>

            <div
              class="col-12 mb-4"
              v-if="allow_fnb_refund == 'Y' && FnbItemArray.length > 0"
            >
              <div class="dropdown-curve-container">
                <label
                  :class="
                    FnbItemArray && FnbItemArray.length > 0 ? 'shift-up' : ''
                  "
                  >{{ $tc("fnb", 2) }}</label
                >
                <multiselect
                  disabled
                  v-model="FnbItemArray"
                  placeholder="Fnb Items"
                  track-by="item_id"
                  label="item_name"
                  :options="FnbItemArray"
                  :multiple="true"
                >
                </multiselect>
              </div>
            </div>

            <div class="col-6 mb-4" v-if="Selected_pm_id == 11 && !onlineMode">
              <div class="input-material">
                <input
                  type="search"
                  v-model="search_ccn"
                  name="cash_card_number"
                  id="cash_card_number"
                  v-debounce:500="onSearchCashCard"
                  v-on:search="onSearchCashCard"
                  placeholder="xxx-xxxxxxxx-x"
                  @focus="onClickInputHandler('showCashCardKeyboard')"
                  :class="{ invalid_input: cc_input_error }"
                />
                <label>{{ "Enter Cash Card Number" }}</label>
                <VkeyboardFloat
                  :ID="'cash_card_number'"
                  :onClickFun="
                    () => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if (x == 'showCashCardKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'cash_card_number'"
                  :showOrHide="keyboardsVisible.showCashCardKeyboard"
                  :initialValue="search_ccn"
                  @onChangeEvent="() => {}"
                  @onKeyEnter="onSearchCashCard"
                  @changeKeyboardInput="search_ccn = $event"
                  @onClickClose="
                    () => {
                      keyboardsVisible.showCashCardKeyboard = false;
                    }
                  "
                />
              </div>
              <p class="error_message">
                <span v-if="cc_input_error">{{ cc_input_error }}</span>
              </p>
            </div>

            <div class="col-12 mb-4" v-if="showCashCardCustomer && !onlineMode">
              <b-collapse v-model="showCashCardCustomer">
                <table
                  class="list-view-table border mb-0"
                  v-if="checkCustomer(cashCardsList[0])"
                >
                  <thead>
                    <tr>
                      <th>{{ $tc("card") }} {{ $tc("number") }}</th>
                      <th>{{ $tc("customer") }} {{ $tc("name") }}</th>
                      <th class="text-right">{{ $t("balance") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(card, key) in cashCardsList" :key="key">
                      <td>{{ card.cash_card_visible }}</td>
                      <td>
                        {{ getCardName(card) }}
                      </td>
                      <td class="text-right">
                        {{ currFormat(card.balance_amount) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table class="list-view-table border mb-0" v-else>
                  <thead>
                    <tr>
                      <th>{{ $tc("card") }} {{ $tc("number") }}</th>
                      <th class="text-center" colspan="2">
                        {{ $t("action") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(card, key) in cashCardsList" :key="key">
                      <td>{{ card.cash_card_visible }}</td>
                      <td class="p-3" colspan="2">
                        <div
                          class="
                            d-flex
                            align-items-center
                            justify-content-center
                          "
                        >
                          <b-form-radio
                            value="1"
                            class="j-radio"
                            v-model="cardSaleType"
                          >
                            <div>
                              <span>{{ $t("street_sale") }}</span>
                            </div>
                          </b-form-radio>
                          <strong class="mx-3">OR</strong>

                          <b-form-radio
                            value="2"
                            class="j-radio"
                            v-model="cardSaleType"
                          >
                            <div>
                              <span>{{ $t("add_customer_details") }}</span>
                            </div>
                          </b-form-radio>
                        </div>
                        <!-- <b-button variant="default" class="btn-blue">{{
                          $t("street_sale")
                        }}</b-button>
                        <b-button variant="default" class="btn-blue">{{
                          $t("add_customer_details")
                        }}</b-button> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-collapse>
            </div>

            <div class="col-6 mb-4" v-if="onlineMode">
              <div class="input-material">
                <input
                  type="text"
                  :disabled="onlineMode"
                  id="online_enterRefundAmount"
                  name="online_enterRefundAmount"
                  :value="BookingDetails.pm_payment_mode"
                />
                <label>{{ "Payment Mode" }}</label>
              </div>
            </div>

            <div class="col-6 mb-4" v-if="onlineMode">
              <div class="input-material">
                <input
                  type="text"
                  :disabled="onlineMode"
                  id="online_enterRefundAmount"
                  name="online_enterRefundAmount"
                  :value="getTotalValue"
                />
                <label>{{ "Refund amount" }}</label>
              </div>
            </div>
          </div>
          <div class="row" v-if="!onlineMode">
            <div class="col-6 mb-4">
              <!-- <p>
                Net Amount: {{ currFormat(refund.sb_total_net_amount) }}&nbsp;{{
                  refund.curr_code
                }}
              </p> -->
              <p>
                Ticket Gross Amount:
                {{ currFormat(refund.sb_total_amount) }}&nbsp;{{
                  refund.curr_code
                }}
              </p>
              <p
                v-if="
                  refund.add_ons_gross_charge && refund.add_ons_gross_charge > 0
                "
              >
                Addons Charges:
                {{ currFormat(refund.add_ons_gross_charge) }}&nbsp;{{
                  refund.curr_code
                }}
              </p>
              <p
                v-if="
                  allow_fnb_refund == 'Y' &&
                    getFnbTotalDetails.fnb_total_amount_before_offer
                "
              >
                FNB Gross Amount:
                {{
                  currFormat(getFnbTotalDetails.fnb_total_amount_before_offer)
                }}&nbsp;{{ refund.curr_code }}
              </p>
              <p
                v-if="
                  (offer_price && parseInt(offer_price) !== 0) ||
                    parseFloat(getFnbTotalDetails.fnb_offer_price)
                "
              >
                Offer Discount:
                {{
                  currFormat(
                    parseFloat(offer_price) +
                      parseFloat(getFnbTotalDetails.fnb_offer_price)
                  )
                }}&nbsp;{{ refund.curr_code }}
              </p>
              <p class="font-weight-bold fs-14">
                Total Amount Paid:
                {{
                  currFormat(
                    refund.sb_total_amount_paid -
                      offer_price +
                      parseFloat(refund.add_ons_gross_charge || 0) +
                      parseFloat(getFnbTotalDetails.fnb_gross_amount)
                  )
                }}&nbsp;{{ refund.curr_code }}
              </p>
            </div>
            <div class="col-6 mb-4" v-if="!onlineMode">
              <div class="input-material" v-if="allow_fnb_refund == 'Y'">
                <input
                  disabled
                  type="text"
                  id="enterOverAllRefundAmount"
                  name="enterOverAllRefundAmount"
                  v-model="totalRefundAmount"
                />
                <label>{{ "Refund amount" }}</label>
              </div>
              <div class="input-material" v-else>
                <input
                  disabled
                  type="text"
                  id="enterRefundAmount"
                  name="enterRefundAmount"
                  v-model="refund.enterRefundAmount"
                  @focus="onClickInputHandler('showAmountKeyboard')"
                />
                <label>{{ "Refund amount" }}</label>
                <VkeyboardFloat
                  :ID="'enterRefundAmount'"
                  :onClickFun="
                    () => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if (x == 'showAmountKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'enterRefundAmount'"
                  :showOrHide="keyboardsVisible.showAmountKeyboard"
                  :initialValue="refund.enterRefundAmount"
                  :keyBoardType="'numeric'"
                  @onChangeEvent="() => {}"
                  @onKeyEnter="
                    () => {
                      keyboardsVisible.showAmountKeyboard = false;
                    }
                  "
                  @changeKeyboardInput="refund.enterRefundAmount = $event"
                  @onClickClose="
                    () => {
                      keyboardsVisible.showAmountKeyboard = false;
                    }
                  "
                />
              </div>
              <div
                class="d-flex align-items-center pt-2 justify-content-end"
                v-if="FnbItemArray.length > 0"
              >
                <b-form-checkbox
                  type="checkbox"
                  class="j-checkbox pb-0"
                  v-model="allow_fnb_refund"
                  unchecked-value="N"
                  value="Y"
                />
                <label class="mb-0 mr-3">{{ "Refund F&B Also" }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <!-- <button class="btn-grey-lg" v-on:click="show1()">{{ $t('cancel') }}</button>
              <button
                v-if="refund.payment_mode_id == 1 && refund.booking_status_id !== 11 && refund.booking_status_id !== 12"
                class="btn-blue-lg"
                v-on:click="show3()"
              >{{ $t('submit') }}</button>-->
              <button
                class="btn btn-outline-blue btn-default"
                v-on:click="show1()"
              >
                {{ $t("cancel") }}
              </button>
              <button
                v-if="onlineMode"
                class="btn-blue"
                :disabled="disableRefundBtn || btnDis"
                :class="disableRefundBtn ? 'disableRefundBtn' : ''"
                v-on:click="processRefund()"
              >
                {{ "Refund " }}&nbsp;{{ getTotalValue }}
              </button>
              <button
                v-else
                class="btn-blue"
                :disabled="disableRefundBtn || btnDis"
                :class="disableRefundBtn ? 'disableRefundBtn' : ''"
                v-on:click="checkRefundPayMode()"
              >
                {{ $t("submit") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="refund-center-content" v-if="section.three">
        <div class="col-lg-6 col-xl-4 mx-auto text-center mb-5">
          <div class="success-tick-wrapper">
            <span class="success-tick"></span>
            <div class="refund-text font-weight-bold mb-3">
              Refund Successfull.
            </div>
          </div>
          <button v-on:click="onClickHandler('PosRefund')" class="btn-blue-lg">
            {{ $t("close") }}
          </button>
          <button
            v-if="checkPrintAvailable"
            v-on:click="onPrintHandler()"
            class="btn-blue-lg"
          >
            {{ $t("Print") }}
          </button>
        </div>
      </div>

      <b-modal
        id="processessingModal"
        ref="processessingModal"
        title="Change Password"
        hide-header
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        centered
        size="sm"
      >
        <div class="loader-wrapper text-center my-5">
          <div class="d-flex justify-content-center">
            <b-spinner
              small
              class="ml-1"
              :variant="'warning'"
              type="grow"
            ></b-spinner>
            <b-spinner
              class="ml-1"
              small
              :variant="'warning'"
              type="grow"
            ></b-spinner>
            <b-spinner
              class="ml-1"
              small
              :variant="'warning'"
              type="grow"
            ></b-spinner>
          </div>
          <h6 class="pt-3 mb-2">Please Wait...</h6>
        </div>
      </b-modal>

      <!-- cinemaManagerLoginPopup -->
      <b-modal
        id="cinemaManagerLoginPopup"
        ref="cinemaManagerLoginPopup"
        title="Change Password"
        hide-header
        hide-footer
      >
        <form>
          <button
            @click.prevent.stop="$bvModal.hide('cinemaManagerLoginPopup')"
            class="btn-modal-close pos-modal-close"
            style="position: absolute; right: 15px; top: 15px; z-index: 99"
          >
            &times;
          </button>
          <div class="row mb-2 mx-0">
            <div class="col-12">
              <div class="text-center mb-4 pb-2 mt-3">
                <h4>Cinema Manager Login</h4>
              </div>
              <div class="col-lg-10 mx-auto align-self-center">
                <div class>
                  <div class="mb-3">
                    <div class="input-material">
                      <input
                        type="text"
                        v-model="username"
                        name="username"
                        id="username"
                        v-validate="'required'"
                        placeholder="username"
                      />
                      <label>Cinema Manager Username</label>
                    </div>
                    <p class="error_message">
                      <span v-if="submitted && errors.has('username')">{{
                        errors.first("username")
                      }}</span>
                    </p>
                  </div>
                  <div class="input-material">
                    <input
                      type="password"
                      v-model="password"
                      name="password"
                      id="password"
                      v-validate="'required'"
                      placeholder="password"
                    />
                    <label>Cinema Manager Password</label>
                  </div>
                  <p class="error_message">
                    <span v-if="submitted && errors.has('password')">{{
                      errors.first("password")
                    }}</span>
                  </p>
                  <div class="d-flex mt-3">
                    <button
                      @click.prevent.stop="
                        $bvModal.hide('cinemaManagerLoginPopup')
                      "
                      class="btn-white-lg w-50 mr-2"
                    >
                      Cancel
                    </button>
                    <button
                      @click.prevent.stop="CheckLogin"
                      class="btn-blue-lg w-50 ml-2"
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </b-modal>
      <b-modal
        id="confirmStockDeduction"
        title="Do You Want To Stock In Items Again?"
        hide-footer
        no-close-on-backdrop
      >
        <div class="pb-1">
          <!-- <p class="fs-16 mb-4">{{ `` }}</p> -->
          <table class="table tableItem">
            <thead>
              <tr>
                <th scope="col" style="white-space: nowrap;">Item Name</th>
                <th scope="col">Qty</th>
                <th scope="col" style="white-space: nowrap;">Add to Stock</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, Itemindex) in FnbItemArray">
                <template
                  v-if="
                    item &&
                      item.hasOwnProperty('combo_data') &&
                      item.combo_data &&
                      item.combo_data.length > 0
                  "
                >
                  <tr
                    v-for="(combo_item, ci_index) in item.combo_data"
                    :key="ci_index"
                  >
                    <td style="word-break:break-word;white-space:break-spaces;"
                      >{{ combo_item.item_name }}&nbsp;({{
                        item.fst_item_name
                      }})</td
                    >
                    <td>{{ combo_item.quantity }}</td>
                    <td>
                      <div class="d-flex align-items-center mx-4">
                        <b-form-checkbox
                          v-model="combo_item.reload_stock"
                          value="Y"
                          @change="onChangeStockReload($event, 'combo', Itemindex, ci_index)"
                          unchecked-value="N"
                          class="j-checkbox mb-1 pb-0"
                          name="check-button"
                        ></b-form-checkbox>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr :key="Itemindex">
                    <td
                      style="word-break:break-word;white-space:break-spaces;"
                      >{{ item.fst_item_name }}</td
                    >
                    <td>{{ item.fst_quantity }}</td>
                    <td>
                      <div class="d-flex align-items-center mx-4">
                        <b-form-checkbox
                          v-model="item.reload_stock"
                          value="Y"
                          @change="onChangeStockReload($event, 'item', Itemindex, null)"
                          unchecked-value="N"
                          class="j-checkbox mb-1 pb-0"
                          name="check-button"
                        ></b-form-checkbox>
                      </div>
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>

          <span class="mx-1"></span>
          <div class="text-center">
            <button
              v-if="onlineMode"
              :disabled="disableRefundBtn"
              :class="disableRefundBtn ? 'disableRefundBtn' : ''"
              class="btn btn-danger btn-danger-lg px-4 fs-14"
              @click.prevent.stop="processRefund(true)"
            >
              Proceed
            </button>
            <button
              v-else
              :disabled="disableRefundBtn"
              :class="disableRefundBtn ? 'disableRefundBtn' : ''"
              class="btn btn-danger btn-danger-lg px-4 fs-14"
              @click.prevent.stop="checkRefundPayMode(true)"
            >
              Proceed
            </button>
          </div>
        </div>
      </b-modal>
    </div>
    <AddCustomerDetailsPopup
      modalId="addcustmodalcashCard"
      :isRefundModal="true"
      :onHideModal="handleOnHideModal"
    />
    <ManagerAuthLogin
      :moduleName="'posRefund'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'authManager_posRefund'"
    />

    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>
  </div>
</template>

<script>
  import PosCashCalculator from "@/components/Partials/posCashCalculator";
  import PosService from "@/services/PosService.js";
  import PosFnbService from "@/services/PosFnbService.js";
  import MasterService from "@/services/MasterService.js";
  import UserService from "@/services/UserService.js";
  import { min } from "moment";
  import { mapState, mapGetters, mapActions } from "vuex";
  import AddCustomerDetailsPopup from "@/components/Partials/AddCustomerDetailsPopup";
  import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
  import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
  import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
  import { generateRandomCode } from "@/helper/collection";
  import _ from "lodash";
  import Printd from "printd";
  import { BASEURL } from "@/config/index";
  import { CLIENT_NAME } from "@/helper/Role";

  export default {
    props: {
      onClickHandler: { type: Function },
    },
    components: {
      PosCashCalculator,
      AddCustomerDetailsPopup,
      Vkeyboard,
      VkeyboardFloat,
      ManagerAuthLogin,
    },
    data() {
      return {
        disableRefundBtn: false,
        overAllRefund: "Y",
        allow_fnb_refund: "Y",
        FnbItemArray: [],
        FnbRefundAmount: 0,
        neoleapCardDetails: {
          card_refund_details: null,
          nl_card_name: null,
          refund_card_payment_gateway: null,
        },
        EjsData: null,
        TemplateList: [],
        online_pm_details: {
          srt_payment_type: null,
        },
        onlineMode: false,
        loaderInstance: null,
        card_payment_gateway: "",
        card_trx_details: "",
        neoPayType: 1,
        neo_orderRef: "",
        neo_ws: null,
        test_response: "",
        neo_retry_count: 0,
        machineDisplay: {
          displayText: "",
          status: true,
          processing: false,
        },

        noAuth: false,
        keyboardsVisible: {
          showV1Keyboard: false,
          showCashCardKeyboard: false,
          showAmountKeyboard: false,
        },
        showV1Keyboard: false,
        Selected_pm_id: null,
        BookingDetails: {
          pm_id: null,
          pm_payment_mode: "",
          bs_id: null,
          booking_source: "",
          ft_total_amount: 0,
          internet_handling_fee: 0,
        },
        btnDis: false,
        isPrivateShow: false,
        cashCardDetails: "",
        cardSaleType: 1, // 1 -> street sale AND 2 -> customer sale
        RefundReason: "",
        section: {
          one: true,
          two: false,
          three: false,
        },
        booking_id: "",
        refund: {
          sb_id: null,
          booking_id: null,
          enterRefundAmount: null,
          //
          booking_status_id: null,
          rr_reason: null,
          rr_id: null,
          payment_mode_id: null,
          payment_mode_name: "",
          //
          curr_code: null,
          sb_total_net_amount: null,
          sb_total_amount: null,
          sb_total_amount_paid: null,
          seat_amount_total: 0,
        },
        username: "",
        password: "",
        submitted: false,
        Refunds: [],
        seats: [],
        Selectedseats: [],
        selectedPayment: "",
        selectedPaymentObj: "",
        offer_name: "",
        offer_price: 0,
        voucher_name: "",
        seatsArray: [],
        cashCardsList: [],
        search_ccn: "",
        cc_input_error: "",

        selectedBooking: "",
        order_code: "",
        OrderItems: [],
        AlreadyRefunded: [],
        refundedApprovedId: null,
      };
    },
    watch: {
      "this.$store.getters.CashCardCustEmail": function(newVal) {
        console.log("this.$store.getters.CashCardCustEmail newVal", newVal);
      },
      "machineDisplay.processing": function(newValue) {
        if (newValue) {
          this.$bvModal.show("processessingModal");
        } else {
          this.$bvModal.hide("processessingModal");
        }
      },
      Selectedseats: {
        handler: function(seat, oldVal) {
          var vm = this;
          vm.refund.seat_amount_total = 0;
          seat.map((x) => {
            vm.refund.seat_amount_total +=
              parseFloat(x.t_gross_amount) +
              parseFloat(vm.addonsChargesObj["perTicketAddonCharge"] || 0);
          });
          if (seat.length == vm.seats.length) {
            vm.refund.seat_amount_total =
              parseFloat(vm.refund.seat_amount_total) +
              parseFloat(vm.addonsChargesObj["overAllAddonsCharge"] || 0);
          }
          vm.refund.enterRefundAmount = parseFloat(
            vm.refund.seat_amount_total
          ).toFixed(2);
        },
        deep: true,
      },
      cardSaleType(newval) {
        if (newval == 2) {
          this.$bvModal.show("addcustmodalcashCard");
        } else if (newval == 1) {
          this.resetCustomerDetails();
          this.MAKE_DATA_EMPTY();
        }
      },
    },
    computed: {
      ...mapGetters([
        "getPaymentTypesList",
        "getCustomerDetails",
        "MANAGER_AUTH_FOR_CHANGES",
        "USE_NEOLEAP_POS_PAYMENT",
        "NEOLEAP_WEBSOCKET_URL",
        "ALLOW_CINEMA_SPECIFIC_REFUND_ONLY",
      ]),
      totalRefundAmount() {
        return this.currFormat(
          parseFloat(this.refund.enterRefundAmount) +
            parseFloat(this.getFnbTotalDetails.fnb_gross_amount)
        );
      },
      getFnbTotalDetails() {
        let obj = {
          fnb_net_amount: 0,
          fnb_gross_amount: 0,
          fnb_offer_price: 0,
          fnb_total_amount_before_offer: 0,
        };
        if (
          (this.FnbItemArray.length > 0 && this.allow_fnb_refund == "Y") ||
          this.onlineMode
        ) {
          this.FnbItemArray.forEach((x) => {
            obj["fnb_net_amount"] += parseFloat(x.fst_amount);
            obj["fnb_gross_amount"] += parseFloat(x.fst_total_amount);
            obj["fnb_gross_amount_before_offer"] += parseFloat(
              x.fst_total_amount_before_offer
            );
            obj["fnb_offer_price"] += parseFloat(x.fst_offer_price);
          });
        }
        return obj;
      },
      _checkPrintAvailable() {
        let status = false;
        if (
          this.TemplateList &&
          this.TemplateList.length > 0 &&
          this.TemplateList[0].refund_temp_name == "Refund-1"
        ) {
          status = true;
        } else {
          status = false;
        }
        return status;
      },
      checkPrintAvailable() {
        return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME;
      },
      getTotalValue() {
        console.log("this.BookingDetails", this.BookingDetails);
        return parseFloat(
          parseFloat(this.refund.sb_total_amount_paid || 0) +
            parseFloat(this.getFnbTotalDetails.fnb_gross_amount || 0) -
            parseFloat(this.offer_price || 0) +
            parseFloat(this.refund.add_ons_gross_charge || 0) +
            parseFloat(this.BookingDetails.internet_handling_fee || 0)
        ).toFixed(2);
      },
      addonsChargesObj() {
        let perTicketAddonCharge = 0;
        let overAllAddonsCharge = 0;
        let addonsArray =
          this.BookingDetails.hasOwnProperty("final_addon_gross_charges") &&
          this.BookingDetails.final_addon_gross_charges.length > 0
            ? this.BookingDetails.final_addon_gross_charges
            : [];

        if (addonsArray.length > 0) {
          addonsArray.forEach((y) => {
            y.map((x) => {
              if (x.is_on_per_ticket == "Y") {
                perTicketAddonCharge += x.single_add_ons_price;
              } else {
                overAllAddonsCharge += x.single_add_ons_price;
              }
            });
          });
        }

        console.log("perTicketAddonCharge", perTicketAddonCharge);
        console.log("overAllAddonsCharge", overAllAddonsCharge);

        return {
          perTicketAddonCharge: perTicketAddonCharge,
          overAllAddonsCharge: overAllAddonsCharge,
        };
      },
      isCashCardRefund() {
        if (this.refund.payment_mode_id == 11) {
          return true;
        } else {
          return false;
        }
      },
      paymentModes() {
        let allowedPmIds = [];
        if (this.BookingDetails.bs_id == 2) {
          //ONLINE BOOKING SOURCE
          if (this.BookingDetails.pm_id == 11) {
            // CASH CARD
            allowedPmIds.push(11);
          } else if (
            this.BookingDetails.pm_id != 12 &&
            this.BookingDetails.pm_id != 13
          ) {
            allowedPmIds.push(11);
          }
        } else if (this.BookingDetails.bs_id == 1) {
          //BOXOFFICE BOOKING SOURCE
          if (this.BookingDetails.pm_id == 1) {
            allowedPmIds.push(1, 11);
          } else if (this.BookingDetails.pm_id == 11) {
            allowedPmIds.push(11);
          } else if (
            this.BookingDetails.pm_id != 12 &&
            this.BookingDetails.pm_id != 13 && 
            (this.USE_NEOLEAP_POS_PAYMENT == "N" || (this.USE_NEOLEAP_POS_PAYMENT == "Y" && !["2", "3"].includes(String(this.BookingDetails.pm_id))))
          ) {
            allowedPmIds.push(1, 11);
          }
        }

        if (
          this.USE_NEOLEAP_POS_PAYMENT == "Y" &&
          ["2", "3"].includes(String(this.BookingDetails.pm_id))
        ) {
          allowedPmIds.push(2, 3);
        }

        if (
          this.online_pm_details.hasOwnProperty("srt_payment_type") &&
          this.online_pm_details.srt_payment_type &&
          ["3", "4", "5"].includes(
            String(this.online_pm_details.srt_payment_type)
          )
        ) {
          allowedPmIds = [];
          console.log("COMING INSIDE line909");
          let pmObj = {
            pm_id: this.BookingDetails.pm_id,
            pm_payment_mode: this.BookingDetails.pm_payment_mode || "Online",
          };
          if (
            !this.getPaymentTypesList.some(
              (x) => x.pm_id == this.BookingDetails.pm_id
            )
          ) {
            this.getPaymentTypesList.push(pmObj);
          }
          allowedPmIds.push(pmObj["pm_id"]);
        }

        // allowedPmIds.push(1);

        let paymentModesList = this.getPaymentTypesList.filter((x) =>
          allowedPmIds.includes(x.pm_id)
        );

        if (paymentModesList.length == 1) {
          console.log("COMING IN onSelectHandlerPayment");
          this.onSelectHandlerPayment(paymentModesList[0]);
        }
        return paymentModesList;
      },
      AllowedPaymentModes() {
        let allowedPmIds = [];
        if (this.BookingDetails.bs_id == 2) {
          //ONLINE BOOKING SOURCE
          if (this.pm_id == 11) {
            // CASH CARD
            allowedPmIds.push(11);
          } else if (!this.pm_id == 12 || !this.pm_id == 13) {
            allowedPmIds.push(11);
          }
        } else if (this.BookingDetails.bs_id == 1) {
          //BOXOFFICE BOOKING SOURCE
          if (this.pm_id == 1) {
            allowedPmIds.push(1, 11);
          } else if (this.pm_id == 11) {
            allowedPmIds.push(11);
          } else if (!this.pm_id == 12 || !this.pm_id == 13) {
            allowedPmIds.push(1, 11);
          }
        }
      },
      CashCardCustEmail() {
        return this.$store.getters.CashCardCustEmail;
      },
      showCashCardCustomer() {
        return this.cashCardsList.length > 0 ? true : false;
      },
    },
    methods: {
      ...mapActions([
        // FETCH FROM MASTER STORE
        "fetchPaymentTypesList",
        "resetCustomerDetails",
        "MAKE_DATA_EMPTY",
      ]),
      validateCinemaSpecificRefund(cinema_id) {
        let status = true;
        let user_cinema_id = this.secureStore.get("USINFO").cinema_id;
        if(this.ALLOW_CINEMA_SPECIFIC_REFUND_ONLY == 'Y') {
          if(cinema_id == user_cinema_id) {
            status = true;
          } else {
            status = false;
          }
        } else {
          status = true;
        }
        return status
      },
      onChangeStockReload(event, type, Itemindex, ci_index = null) {
        if(type == 'combo' && ci_index) {
          this.FnbItemArray[Itemindex].combo_data[ci_index].reload_stock = event;
        } else {
          this.FnbItemArray[Itemindex].reload_stock = event;
        }
      },
      processRefund: function(confirmStock = false) {
        if (
          !confirmStock &&
          this.secureStore.get("BRGLOPSTDE") &&
          this.allow_fnb_refund == "Y" &&
          this.FnbItemArray.length > 0
        ) {
          this.$bvModal.show("confirmStockDeduction");
        } else if (this.refund.rr_id) {
          this.$bvModal.hide("confirmStockDeduction");
          let data = {
            ...this.BookingDetails,
            ...this.refund,
            ...this.online_pm_details,
          };
          this.Selectedseats = _.cloneDeep(this.seats);
          if (data) {
            this.selectedBooking = data;
            this.booking_id = data.sb_booking_code;
            this.order_code = data.order_code;
          }

          if (this.booking_id == "") {
            return this.$toasted.show("Enter Booking ID");
          } else {
            this.disableRefundBtn = true;
            let payload = {
              booking_id: this.booking_id,
              order_code: this.order_code,
            };

            PosService.GetFnbOrderDetails({ ...payload })
              .then((response) => {
                const { data } = response;
                console.log("GetFnbOrderDetails", data);

                if (data && data.status) {
                  this.OrderItems = data.Records.filter(
                    (x) => x.refund_datetime == null && x.is_refund == "N"
                  ).map((y) => {
                    return { ...y, keyboardActive: false };
                  });

                  if (this.OrderItems && this.OrderItems.length > 0) {
                    this.OrderItems.forEach((fi) => {
                      fi["reload_stock"] = "N";
                      if (fi.hasOwnProperty("combo_data") && fi.combo_data) {
                        fi["combo_data"] = fi.combo_data
                          ? JSON.parse(fi.combo_data)
                          : [];
                        if (fi.combo_data.length > 0) {
                          fi.combo_data.map((c) => {
                            c["reload_stock"] = "N";
                          });
                        }
                      }
                    });
                  }

                  this.AlreadyRefunded = data.Records.filter(
                    (x) => x.refund_datetime != null && x.is_refund == "Y"
                  );
                }
              })
              .catch((err) => {
                this.disableRefundBtn = false;
                return Promise.resolve();
              })
              .then(() => {
                console.log("COMING HERE IN updatePGRefundStatus REFUND");
                this.updatePGRefundStatus();
              });
          }
        } else {
          this.$bvModal.hide("confirmStockDeduction");
          this.$toasted.show("Please Select Refund Reason");
        }
      },

      updateBrijRefundStatus: function() {
        let pm = this.refund.payment_mode_id
          ? this.getPaymentTypesList.filter(
              (x) => x.pm_id == this.refund.payment_mode_id
            )[0]
          : {
              pm_payment_mode:
                this.selectedBooking.srt_payment_type == "3" // 'Amazon PayFort'
                  ? "Amazon PayFort"
                  : this.selectedBooking.srt_payment_type == "4" // 'Master/Visa'
                  ? "Master/Visa"
                  : this.selectedBooking.srt_payment_type == "5" // 'Al Rajhi Bank'
                  ? "Al Rajhi Bank"
                  : "",
            };

        this.selectedPayment = pm.pm_payment_mode;
        if (!this.RefundReason || !this.refund.rr_id) {
          let rr =
            this.Refunds.filter((x) => x.rr_id == this.refund.rr_id)[0] ||
            this.Refunds[0];
          this.RefundReason = rr.rr_reason;
          this.refund.rr_id = rr.rr_id;
        }

        this.refund.seat_amount_total = 0;

        this.Selectedseats.map((x) => {
          this.refund.seat_amount_total =
            parseFloat(this.refund.seat_amount_total) +
            parseFloat(x.t_gross_amount);
        });

        this.refund.seat_amount_total += parseFloat(
          this.refund.total_add_ons_charge
        );
        this.refund.seat_amount_total += parseFloat(
          this.refund.internet_handling_fee
        );
        this.refund.enterRefundAmount = this.refund.seat_amount_total.toFixed(
          2
        );

        // fnb stuff
        if (this.order_code) {
          let refundAmount = 0;
          this.OrderItems.forEach((x) => {
            x.refund_reason = this.RefundReason;
            x.refund_payment_mode_id = this.refund.payment_mode_id;
            x.refund_payment_mode_name = this.refund.payment_mode_name;
            x.is_refund = "Y";
            refundAmount = +parseFloat(x.refunded_amount) + refundAmount;
          });
        }
        this.disableRefundBtn = true;

        if (String(this.refund.booking_status_id) === "12") {
          console.log("Refund has been done");
          this.$toasted.show("Refund has been done");
          this.disableRefundBtn = false;
        } else if (
          !pm ||
          !this.refund.enterRefundAmount ||
          this.refund.enterRefundAmount.length == 0
        ) {
          console.log("Please enter refund amount");
          this.$toasted.show("Please enter refund amount");
          this.disableRefundBtn = false;
        } else if (!this.selectedPayment || this.selectedPayment.length == 0) {
          console.log("Please select payment mode");
          this.$toasted.show("Please select payment mode");
          this.disableRefundBtn = false;
          return;
        } else {
          let ssb_ids = [];
          let sl_ids = [];
          this.Selectedseats.map((y) => {
            this.seats.map((x) => {
              if (x.sl_id == y.sl_id) {
                ssb_ids.push(y.ssb_id);
                sl_ids.push(y.sl_id);
              }
            });
          });
          let payload = {
            ...this.refund,
            ssb_id: ssb_ids,
            sl_id: sl_ids,
            refund_payment_mode_id: this.refund.payment_mode_id
          };

          if (this.onlineMode) {
            payload["skipTransactionCash"] = "Y";
          }

          return PosService.updateRefundStatus(payload)
            .then((response) => {
              this.$store.dispatch("onSetAndSendLog", {
                action: ` Selected refund for :${this.booking_id} and refund amount to be given was : ${this.refund.enterRefundAmount} `,
                page_name: "Dashboard Refund",
                api_name: window.location.hash,
              });
              const { data } = response;
              if (data && data.status) {
                this.section.one = true;
                this.section.two = false;
                // this.$toasted.show(data.message);
              } else {
                // this.$toasted.show(data.message);
              }
            })
            .then(() => {
              if (this.order_code) {
                console.log({
                  "this.order_code": this.order_code,
                });

                let payload = {
                  fnbRefundList: this.OrderItems,
                  cinema_id: this.selectedBooking.cine_id,
                };

                if (this.onlineMode) {
                  payload["skipTransactionCash"] = "Y";
                }
                // if (this.isCashCardRefund) {
                //   payload["cashCardDetails"] = this.cashCardDetails;
                // }
                return PosService.fnbRefund(payload)
                  .then((response) => {
                    const { data } = response;
                    if (data && data.status) {
                      // this.$toasted.show(data.message);
                    } else {
                      // this.$toasted.show(data.message);
                    }
                  })
                  .catch((err) => {
                    this.disableRefundBtn = false;
                    console.log("fnbRefund Error: ", err);
                  });
              }
            })
            .finally(() => {
              // this.onClickHandler("PosRefund");
              this.disableRefundBtn = false;
              this.section.three = true;
              this.section.one = false;
              this.section.two = false;
              this.onPrintHandler();
            });
        }
      },

      updatePGRefundStatus() {
        this.loaderInstance = this.$loading.show();
        this.disableRefundBtn = true;
        let payload = {
          reservation_id: this.selectedBooking.reservation_id,
          cinema_id: this.selectedBooking.cine_id,
          currency: this.refund.curr_code,
          fort_id:
            this.selectedBooking.payment_transaction_detail.fort_id || "",
          sr_id: this.selectedBooking.sr_id || "",
          pm_payment_mode:
            this.selectedBooking.srt_payment_type == "3" // 'Amazon PayFort'
              ? "Amazon PayFort"
              : this.selectedBooking.srt_payment_type == "4" // 'Master/Visa'
              ? "Master/Visa"
              : this.selectedBooking.srt_payment_type == "5" // 'Al Rajhi Bank'
              ? "Al Rajhi Bank"
              : "",

          amount:
            this.getSafe(
              () => this.selectedBooking.payment_transaction_detail.amount
            ) ||
            this.getSafe(
              () => this.selectedBooking.payment_transaction_detail.amt
            ),
        };

        return PosService.PaymentGatewayRefundApi(payload)
          .then((resData) => {
            console.log({
              resData,
            });
            console.log("resData line 1134", resData);
            if (resData.data.status == true) {
              this.$forceUpdate();
              this.$toasted.show(resData.data.message);
              return this.updateBrijRefundStatus();
            } else {
              this.$toasted.show(
                typeof resData.data.message == "string"
                  ? resData.data.message
                  : "Something Went Wrong!."
              );
              return Promise.reject();
            }
          })
          .catch((error) => {
            this.disableRefundBtn = false;
            console.log("ERROR line 1146", error);
            console.log({ error });
          })
          .finally(() => {
            this.loaderInstance && this.loaderInstance.hide();
          });
      },
      onCheckAuthentication(response) {
        const { valid, name, user_id } = response;
        if (valid) {
          if (name == "posRefund") {
            if (this.refundedApprovedId == null) {
              this.refundedApprovedId = user_id;
            }
            this.noAuth = true;
            this.show2();
            this.$bvModal.hide("authManager_posRefund");
          }
        }
      },
      checkAllowedRefundMode() {},
      async onClickInputHandler(event) {
        if (
          Object.keys(this.keyboardsVisible).some(
            (x) => this.keyboardsVisible[x] == true
          )
        ) {
          let Promises = Object.keys(this.keyboardsVisible).map((x) => {
            this.keyboardsVisible[x] = false;
          });
          await Promise.all(Promises);
          this.keyboardsVisible[event] = true;
          console.log("this.keyboardsVisible", this.keyboardsVisible);
          this.$forceUpdate();
        }
      },
      handleOnHideModal() {
        console.log(
          "coming handleOnHideModal posRefund",
          this.getCustomerDetails
        );
        if (
          !this.getCustomerDetails ||
          Object.keys(this.getCustomerDetails).length == 0
        ) {
          this.cardSaleType = 1;
        }
      },
      checkPaymentModeValidation() {
        let count = 0;
        let error_msg = "";
        if (this.isCashCardRefund) {
          if (!this.search_ccn) {
            count++;
            this.cc_input_error = "Please Enter Cash Card Number";
          } else if (this.cashCardsList.length == 0) {
            count++;
            error_msg = "No Cash Card Details Found";
            this.$toasted.show(error_msg);
          }
        }
        if (count > 0) {
          return false;
        } else {
          return true;
        }
      },
      checkIsStreetSale(card) {
        if (card && card.hasOwnProperty("customer_id") && card.customer_id) {
          return false;
        } else if (
          card &&
          card.hasOwnProperty("is_guest_user") &&
          card.is_guest_user == "Y"
        ) {
          return false;
        } else if (card && card.is_street_sale == "Y") {
          return true;
        } else {
          return true;
        }
      },
      checkCustomer(card) {
        if (card && card.hasOwnProperty("customer_id") && card.customer_id) {
          return true;
        } else if (
          card &&
          card.hasOwnProperty("is_guest_user") &&
          card.is_guest_user == "Y"
        ) {
          return true;
        } else if (card && card.is_street_sale == "Y") {
          return true;
        } else {
          return false;
        }
      },
      getCardName(card) {
        let name = ``;
        if (card.customer_id) {
          name = `${card.first_name} ${card.last_name ? card.last_name : ""}`;
        } else if (
          card &&
          card.hasOwnProperty("is_guest_user") &&
          card.is_guest_user == "Y"
        ) {
          name = `${card.guest_first_name} ${
            card.guest_last_name ? card.guest_last_name : ""
          }`;
        } else if (card.is_street_sale == "Y") {
          name = `Street Sale`;
        } else {
          name = "-";
        }
        return name;
      },
      onSearchCashCard() {
        this.cc_input_error = "";
        if (this.search_ccn) {
          if (this.search_ccn.replace(/\s/g, "").length !== 12) {
            this.cc_input_error = "Please Enter 12 digit Card Number";
          } else if (isNaN(this.search_ccn.replace(/\s/g, ""))) {
            this.cc_input_error = "Please Enter Valid Cash Card Number";
          } else {
            this.getCashCardDetails();
          }
        } else {
          this.cashCardsList = [];
        }
      },
      getCashCardDetails: function() {
        let loader = this.$loading.show();
        this.cashCardsList = [];
        let payload = {
          perPage: 10,
          currentPage: 1,
          columnName: "",
          orderBy: "created_at",
          searchValue: this.search_ccn,
          filter_is_active: "Y",
        };

        PosService.GetCashCardList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.data.length > 0) {
              this.cashCardsList = data.Records.data;
            } else {
              this.cashCardsList = [];
              this.$toasted.show(this.$t("No Cash Cards Found"));
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      onSelectHandler: function(item) {
        this.RefundReason = item.rr_reason;
        this.refund.rr_id = item.rr_id;
      },
      onSelectSeats(seat) {
        if (Array.isArray(seat)) {
          seat.map((x) => {
            this.refund.seat_amount_total =
              parseFloat(this.refund.seat_amount_total) +
              parseFloat(x.t_gross_amount) +
              parseFloat(this.addonsChargesObj["perTicketAddonCharge"] || 0);
          });
        } else {
          this.refund.seat_amount_total =
            parseFloat(this.refund.seat_amount_total) +
            parseFloat(seat.t_gross_amount) +
            parseFloat(this.addonsChargesObj["perTicketAddonCharge"] || 0);
        }

        this.refund.enterRefundAmount = this.refund.seat_amount_total.toFixed(
          2
        );
      },
      onRemoveSeats(seat) {
        if (Array.isArray(seat)) {
          seat.map((x) => {
            this.refund.seat_amount_total =
              parseFloat(this.refund.seat_amount_total) -
              parseFloat(x.t_gross_amount) -
              parseFloat(this.addonsChargesObj["perTicketAddonCharge"] || 0);
          });
        } else {
          this.refund.seat_amount_total =
            parseFloat(this.refund.seat_amount_total) -
            parseFloat(seat.t_gross_amount) -
            parseFloat(this.addonsChargesObj["perTicketAddonCharge"] || 0);
        }

        this.refund.enterRefundAmount = this.refund.seat_amount_total.toFixed(
          2
        );
      },
      onSelectHandlerPayment: function(item) {
        this.selectedPaymentObj = item;
        this.selectedPayment = item.pm_payment_mode;
        this.Selected_pm_id = item.pm_id;
        this.refund.payment_mode_id = item.pm_id;
        this.refund.payment_mode_name = item.pm_payment_mode;
        
        if (
          item.pm_payment_mode == "Online" ||
          ["20", "21", "22", "18"].includes(String(item.pm_id))
        ) {
          this.onlineMode = true;
        } else {
          this.onlineMode = false;
        }
        if (item.pm_id == 11 && this.BookingDetails.cash_card_number) {
          this.search_ccn = this.BookingDetails.cash_card_number;
          this.onSearchCashCard();
        }
      },
      onRemovePaymentMode: function(item) {
        this.selectedPayment = "";
        this.refund.payment_mode_id = null;
        this.cashCardsList = [];
        this.onlineMode = false;
      },
      callClose: function() {
        this.onClickHandler("PosRefund");
      },
      show1: function() {
        this.section.one = true;
        this.section.two = false;
      },
      show2: function() {
        if (this.booking_id == "") {
          this.$toasted.show("Enter Booking ID");
        } else if (this.MANAGER_AUTH_FOR_CHANGES == "Y" && !this.noAuth) {
          this.$bvModal.show("authManager_posRefund");
        } else {
          this.getRefunds();
          this.fetchPaymentTypesList();
          this.getCinemaTicketTemplate();
          let payload = {
            booking_id: this.booking_id,
          };
          PosService.getRefundReason(payload)
            .then((result) => {
              const { data } = result;
              if (data && data.status && !data.needCinemaManagerLogin) {
                this.section.one = false;
                this.section.two = true;
                this.RefundReason = data.Records[0].rr_reason;
                this.card_trx_details = data.Records[0].card_trx_details;
                this.card_payment_gateway =
                  data.Records[0].card_payment_gateway;
                this.seats = data.Records;
                this.seatsArr = [
                  {
                    label: "All",
                    SeatsArray: data.Records,
                  },
                ];
                this.Selectedseats = data.Records.filter((x) => {
                  return x.sl_id;
                });
                // this.getPaymentTypesList.map((x) => {
                //   if (x.pm_id == data.Records[0].payment_mode_id) {
                //     this.selectedPayment = x.pm_payment_mode;
                //   }
                // });
                // this.selectedPayment =
                this.refund = {
                  booking_id: this.booking_id,
                  ...this.refund,
                  ...data.Records[0],
                };
                // if (
                //   this.refund.booking_status_id == "11" ||
                //   this.refund.booking_status_id == "12"
                // ) {
                //   this.$toasted.show(
                //     "You have already applied for refund or you are not eligible for cash refund"
                //   );
                // }
              } else if (!data.status && data.needCinemaManagerLogin) {
                // this.$refs.cinemaManagerLoginPopup.show();
                this.CheckLogin();
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      },
      neoPaymentSuccessfull(responseData) {
        //Make Booking
        this.disableRefundBtn = false
        this.neo_orderRef = "";
        this.neoleapCardDetails["card_refund_details"] = responseData
          ? responseData
          : null;
        this.neoleapCardDetails["nl_card_name"] = responseData.hasOwnProperty(
          "CardNameEnglish"
        )
          ? responseData["CardNameEnglish"]
          : null;
        this.neoleapCardDetails["refund_card_payment_gateway"] = "NEOLEAP";
        this.machineDisplay.processing = false;
        console.log("Refund Processed!");
        this.show3();
      },
      neoPaymentFailed(responseData, message = "") {
        this.machineDisplay.processing = false;
        this.disableRefundBtn = false
        if (message) {
          this.$toasted.show(message);
        }
      },
      checkNeoLeapStatus(type) {
        this.neoPayType = type;
        this.machineDisplay.processing = true;
        let checkObj = { Command: "CHECK_STATUS" };
        this.requestNeoLeap(JSON.stringify(checkObj));
      },
      retryNeoTransaction() {
        this.neo_retry_count++;
        this.machineDisplay.processing = true;
        let lastTrxObj = { Command: "GET_LAST_TRX" };
        this.requestNeoLeap(JSON.stringify(lastTrxObj));
      },
      proceedNeoleap(type = 1) {
        this.machineDisplay.processing = true;
        let amount = 0;
        this.neo_orderRef =
          this.card_trx_details &&
          this.card_trx_details.hasOwnProperty("ECRReferenceNumber")
            ? this.card_trx_details["ECRReferenceNumber"]
            : generateRandomCode(8);
        amount = parseFloat(this.refund.enterRefundAmount).toFixed(2);
        let Original_RRN =
          this.card_trx_details &&
          this.card_trx_details.hasOwnProperty("RetrievalReferenceNumber")
            ? this.card_trx_details["RetrievalReferenceNumber"]
            : "";
        if (this.allow_fnb_refund == "Y") {
          amount += parseFloat(this.FnbRefundAmount || 0);
        }

        let paymentObj = {
          Command: "REFUND",
          Amount: String(amount),
          Original_RRN: Original_RRN,
          MaskedPAN: "",
          PrintFlag: "1",
          AdditionalData: String(this.neo_orderRef),
        };
        this.requestNeoLeap(JSON.stringify(paymentObj));
      },
      requestNeoLeap(jsonRequest) {
        if (this.neo_ws.readyState == WebSocket.OPEN) {
          console.log("requestNeoLeap jsonRequest", jsonRequest);
          var res = this.neo_ws.send(jsonRequest);
        } else {
          this.$toasted.show("Connection is Closed " + this.neo_ws.readyState);
        }
      },
      disConnectNeoLeap() {
        this.neo_ws.close();
      },
      createNeoleapWebSocket() {
        let self = this;
        let WS_URL =
          this.NEOLEAP_WEBSOCKET_URL ||
          "wss://localhost:7000/neoleap_integration";
        this.neo_ws = new WebSocket(WS_URL);

        this.neo_ws.onopen = function() {
          // connection opened – add action here
          console.log("Connected");
          self.$toasted.show("Connected");
          setTimeout(() => {
            self.checkNeoLeapStatus(1);
          }, 1000);
        };

        this.neo_ws.onmessage = function(evt) {
          console.log("onmessage evt", evt);
          if (evt.data) {
            let responseData = evt.data ? JSON.parse(evt.data) : "";

            console.log("responseData onmessage", responseData);

            if (
              !responseData.hasOwnProperty("EventName") &&
              !responseData.EventName &&
              responseData.hasOwnProperty("API_Status")
            ) {
              let errorMsg = `FAILED`;
              self.machineDisplay.processing = false;

              if (["2", "6"].includes(String(responseData.API_Status))) {
                if (self.neo_retry_count < 2) {
                  self.retryNeoTransaction();
                } else {
                  switch (responseData.API_Status) {
                    case "2":
                      errorMsg = `NO RESPONSE`;
                      break;
                    case "6":
                      errorMsg = `API TIMEOUT`;
                      break;
                    default:
                      errorMsg = `FAILED`;
                      break;
                  }
                  self.$toasted.show(errorMsg);
                }
              } else {
                switch (responseData.API_Status) {
                  case "3":
                    errorMsg = `PORT ASSIGNED IS NOT PRESENT OR USED BY ANOTHER PROCESS.`;
                    break;
                  case "4":
                    errorMsg = `UNEXPECTED ERROR OCCURRED, REQUEST CANCELLED`;
                    break;
                  default:
                    errorMsg = `FAILED`;
                    break;
                }
                self.$toasted.show(errorMsg);
              }
            } else if (responseData.EventName == "TERMINAL_STATUS") {
              if (responseData.TerminalStatus == "READY") {
                self.proceedNeoleap(responseData);
              } else if (responseData.TerminalStatus == "BUSY") {
                self.neoPaymentFailed(
                  responseData,
                  "Terminal is " + responseData.TerminalStatus
                );
              } else {
                self.neoPaymentFailed(responseData, "Something Went Wring");
              }
            } else if (responseData.EventName == "TERMINAL_RESPONSE") {
              if (responseData.API_Status == "0") {
                if (
                  responseData.hasOwnProperty("JsonResult") &&
                  responseData.JsonResult
                ) {
                  if (
                    responseData.JsonResult.StatusCode == "00" &&
                    responseData.JsonResult.TransactionTypeEnglish ==
                      "REFUND" &&
                    responseData.JsonResult.TransactionResponseEnglish ==
                      "APPROVED"
                  ) {
                    if (
                      responseData.JsonResult.ECRReferenceNumber ==
                      self.neo_orderRef
                    ) {
                      self.$toasted.show(
                        responseData.JsonResult.TransactionResponseEnglish
                      );
                      self.neoPaymentSuccessfull(responseData.JsonResult);
                    } else {
                      self.neoPaymentFailed(
                        responseData,
                        "FAILED, PLEASE TRY AGAIN!"
                      );
                    }
                  } else {
                    self.machineDisplay.processing = false;
                    self.$toasted.show(
                      responseData.JsonResult.TransactionResponseEnglish
                    );
                  }
                } else {
                  self.machineDisplay.processing = false;
                  self.$toasted.show("No Response");
                  // self.retryNeoTransaction()
                }
              } else {
                // self.retryNeoTransaction()
                self.neoPaymentFailed(responseData, "Failed");
              }
            } else if (responseData.EventName == "TERMINAL_ACTION") {
              console.log("SWIPE CARD");
            } else {
              self.machineDisplay.processing = false;
            }
          } else {
            console.log("ELSE evt", evt);
          }
        };
        this.neo_ws.onerror = function(evt) {
          console.log("evt.message onerror", evt.message);
          // error can be determined on evt.message
        };
        this.neo_ws.onclose = function() {
          console.log("Neo Leap Closed");
          // connection closed
        };
      },
      proceedCreditCardRefund() {
        this.$bvModal.show("processessingModal");
        this.createNeoleapWebSocket();
        this.machineDisplay.processing = true;
      },
      checkRefundPayMode(confirmStock = false) {
        let ssb_ids = [];
        let sl_ids = [];

        this.Selectedseats.map((y) => {
          this.seats.map((x) => {
            if (x.sl_id == y.sl_id) {
              ssb_ids.push(y.ssb_id);
              sl_ids.push(y.sl_id);
            }
          });
        });

        let refundPayload = {
          ...this.refund,
          ssb_id: ssb_ids,
          sl_id: sl_ids,
        };
        if (
          !confirmStock &&
          this.secureStore.get("BRGLOPSTDE") &&
          this.allow_fnb_refund == "Y" &&
          this.FnbItemArray.length > 0
        ) {
          this.$bvModal.show("confirmStockDeduction");
        } else if (
          ["2", "3"].includes(String(this.Selected_pm_id)) &&
          this.USE_NEOLEAP_POS_PAYMENT == "Y"
        ) {
          this.$bvModal.hide("confirmStockDeduction");
          if (String(this.refund.booking_status_id) === "12") {
            this.$toasted.show("Refund has been done");
          } else if (
            !this.refund.enterRefundAmount ||
            this.refund.enterRefundAmount.length == 0
          ) {
            this.$toasted.show("Please enter refund amount");
          } else if (
            !this.selectedPayment ||
            this.selectedPayment.length == 0
          ) {
            this.$toasted.show("Please select payment mode");
            return;
          } else if (
            refundPayload.enterRefundAmount &&
            +parseFloat(refundPayload.enterRefundAmount).toFixed(2) >
              +parseFloat(
                refundPayload.total_add_ons_charge +
                  refundPayload.internet_handling_fee +
                  refundPayload.add_ons_gross_charge +
                  refundPayload.sb_total_amount -
                  refundPayload.t_offer_price * refundPayload.sb_no_of_seats
              ).toFixed(2)
          ) {
            this.$toasted.show(
              "Refund amount cannot be greater than total amount paid"
            );
            return;
          } else if (
            refundPayload.enterRefundAmount &&
            refundPayload.seat_amount_total &&
            +parseFloat(refundPayload.enterRefundAmount).toFixed(2) >
              +parseFloat(refundPayload.seat_amount_total).toFixed(2)
          ) {
            this.$toasted.show(
              "Refund amount cannot be greater than selected seat amount"
            );
            return;
          } else if (!this.checkPaymentModeValidation()) {
            return;
          } else {
            this.disableRefundBtn = true
            this.proceedCreditCardRefund();
          }
        } else {
          this.$bvModal.hide("confirmStockDeduction");
          this.show3();
        }
      },
      show3: function() {
        if (String(this.refund.booking_status_id) === "12") {
          this.$toasted.show("Refund has been done");
        } else if (
          !this.refund.enterRefundAmount ||
          this.refund.enterRefundAmount.length == 0
        ) {
          this.$toasted.show("Please enter refund amount");
        } else if (!this.selectedPayment || this.selectedPayment.length == 0) {
          this.$toasted.show("Please select payment mode");
          return;
        } else if (!this.checkPaymentModeValidation()) {
          return;
        } else if (this.overAllRefund == "Y") {
          this.refundOverallAmount();
        } else {
          this.disableRefundBtn = true
          let ssb_ids = [];
          let sl_ids = [];
          console.log("this.seats :", this, this.seats);
          console.log("this.Selectedseats :", this.Selectedseats);
          this.Selectedseats.map((y) => {
            this.seats.map((x) => {
              if (x.sl_id == y.sl_id) {
                ssb_ids.push(y.ssb_id);
                sl_ids.push(y.sl_id);
              }
            });
          });
          if (this.isCashCardRefund && this.cashCardsList.length > 0) {
            this.cashCardDetails = {
              cash_card_number: this.cashCardsList[0].cash_card_number,
              customer_email: this.cashCardsList[0].cust_email
                ? this.cashCardsList[0].cust_email
                : this.getCustomerDetails
                ? this.getCustomerDetails.cust_email
                : this.CashCardCustEmail
                ? this.CashCardCustEmail
                : this.cashCardsList[0].guest_email
                ? this.cashCardsList[0].guest_email
                : "",
              type: "1",
              isNewCashCard: this.checkCustomer(this.cashCardsList[0])
                ? "N"
                : "Y",
              isStreetSale:
                this.checkIsStreetSale(this.cashCardsList[0]) &&
                this.cardSaleType == 1
                  ? "Y"
                  : "N",
              amount: this.refund.enterRefundAmount,
              payment_mode_id: 1,
              cash_log_reason: `Refund Booking ID - ${this.booking_id}`,
              credit_by_refund: "Y",
            };
          }
          let payload = {
            ...this.refund,
            ssb_id: ssb_ids,
            sl_id: sl_ids,
            refundApprovedBy: this.refundedApprovedId,
            refund_payment_mode_id: this.refund.payment_mode_id
          };
          if (this.isCashCardRefund) {
            payload["cashCardDetails"] = this.cashCardDetails;
          }
          if (this.onlineMode) {
            payload["skipTransactionCash"] = "Y";
          }
          if (
            this.neoleapCardDetails["refund_card_payment_gateway"] == "NEOLEAP"
          ) {
            payload["neoleapCardDetails"] = this.neoleapCardDetails;
          }
          console.log("payload :", payload);
          this.btnDis = true;
          let loader = this.$loading.show();
          PosService.updateRefundStatus(payload)
            .then((response) => {
              this.$store.dispatch("onSetAndSendLog", {
                action: ` Selected refund for :${this.booking_id} and refund amount to be given was : ${this.refund.enterRefundAmount} `,
                page_name: "POS booking",
                api_name: window.location.hash,
              });
              const { data } = response;
              if (data && data.status) {
                // this.onClickHandler("PosRefund");
                this.disableRefundBtn = false;
                this.section.three = true;
                this.section.one = false;
                this.section.two = false;
                this.onPrintHandler();
                if (this.isCashCardRefund) {
                  this.resetCustomerDetails();
                  this.MAKE_DATA_EMPTY();
                }
                // this.section.three = true;
                this.$toasted.show(data.message);
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError)
            .finally(() => {
              setTimeout(() => {
                this.btnDis = false;
                this.disableRefundBtn = false;
                loader.hide();
              }, 1000);
            });
        }
      },
      refundOverallAmount() {
        let loader = this.$loading.show();
        this.btnDis = true;
        this.disableRefundBtn = true;
        let ssb_ids = [];
        let sl_ids = [];
        console.log("this.Selectedseats :", this.Selectedseats);
        this.Selectedseats.map((y) => {
          this.seats.map((x) => {
            if (x.sl_id == y.sl_id) {
              ssb_ids.push(y.ssb_id);
              sl_ids.push(y.sl_id);
            }
          });
        });
        if (this.isCashCardRefund && this.cashCardsList.length > 0) {
          this.cashCardDetails = {
            cash_card_number: this.cashCardsList[0].cash_card_number,
            customer_email: this.cashCardsList[0].cust_email
              ? this.cashCardsList[0].cust_email
              : this.getCustomerDetails
              ? this.getCustomerDetails.cust_email
              : this.CashCardCustEmail
              ? this.CashCardCustEmail
              : this.cashCardsList[0].guest_email
              ? this.cashCardsList[0].guest_email
              : "",
            type: "1",
            isNewCashCard: this.checkCustomer(this.cashCardsList[0])
              ? "N"
              : "Y",
            isStreetSale:
              this.checkIsStreetSale(this.cashCardsList[0]) &&
              this.cardSaleType == 1
                ? "Y"
                : "N",
            amount: this.refund.enterRefundAmount,
            payment_mode_id: 1,
            cash_log_reason: `Refund Booking ID - ${this.booking_id}`,
            credit_by_refund: "Y",
          };
        }
        let payload = {
          ...this.refund,
          ssb_id: ssb_ids,
          sl_id: sl_ids,
          refundApprovedBy: this.refundedApprovedId,
          refund_payment_mode_id: this.refund.payment_mode_id
        };
        if (this.isCashCardRefund) {
          payload["cashCardDetails"] = this.cashCardDetails;
        }
        if (this.onlineMode) {
          payload["skipTransactionCash"] = "Y";
        }
        if (
          this.neoleapCardDetails["refund_card_payment_gateway"] == "NEOLEAP"
        ) {
          payload["neoleapCardDetails"] = this.neoleapCardDetails;
        }

        PosService.updateRefundStatus(payload)
          .then((response) => {
            const { data: data_1 } = response;
            if (data_1 && data_1.status) {
              this.ApplyFnbRefund()
                .then((response_fnb) => {
                  if (response_fnb && response_fnb.status) {
                    this.disableRefundBtn = false;
                    this.section.three = true;
                    this.section.one = false;
                    this.section.two = false;
                    this.onPrintHandler();
                    if (this.isCashCardRefund) {
                      this.resetCustomerDetails();
                      this.MAKE_DATA_EMPTY();
                    }
                    this.$toasted.show(data_1.message);
                  } else {
                    this.$toasted.show(response_fnb.message);
                  }
                })
                .catch(this._CatchError);
            } else {
              this.$toasted.show(data_1.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              this.btnDis = false;
              this.disableRefundBtn = false;
              loader.hide();
            }, 1000);
          });
      },
      ApplyFnbRefund() {
        let f_refundAmount = 0;
        const { cinema_id } = this.secureStore.get("USINFO");
        return new Promise((resolve, reject) => {
          if (this.allow_fnb_refund == "Y" && this.FnbItemArray.length > 0) {
            this.FnbItemArray.forEach((x) => {
              x.refund_reason = this.RefundReason;
              x.refund_payment_mode_id = this.refund.payment_mode_id;
              x.refund_payment_mode_name = this.refund.payment_mode_name;
              x.is_refund = "Y";
              x.refunded_amount = +parseFloat(x.total_price);
              f_refundAmount = +parseFloat(x.total_price) + f_refundAmount;
            });

            console.log("Final Array", this.FnbItemArray);

            let payload = {
              fnbRefundList: this.FnbItemArray,
              cinema_id: this.BookingDetails.cine_id || cinema_id,
            };

            if (this.isCashCardRefund && this.cashCardsList.length > 0) {
              let FnbCashCardObj = _.cloneDeep(this.cashCardDetails);
              FnbCashCardObj["amount"] = parseFloat(f_refundAmount);
              payload["cashCardDetails"] = FnbCashCardObj;
            }

            if (this.onlineMode) {
              payload["skipTransactionCash"] = "Y";
            }

            if (
              this.neoleapCardDetails["refund_card_payment_gateway"] ==
              "NEOLEAP"
            ) {
              payload["neoleapCardDetails"] = this.neoleapCardDetails;
            }

            PosService.fnbRefund(payload)
              .then((response) => {
                const { data } = response;
                resolve(data);
              })
              .catch((err) => {
                console.log("Error: ", err);
                resolve({
                  status: false,
                  message: "Something Went Wrong in Fnb Refund",
                  err,
                });
              });
          } else {
            resolve({
              status: true,
              message: "No Fnb Item For Refund",
            });
          }
        });
      },
      getRefunds: function() {
        let body = {
          tableName: "ms_refund_reasons",
          rr_is_active: "Y",
        };
        MasterService.GetActiveList(body)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.Refunds = data.Records;
            } else
              this.$toasted.show(data.message || "Opps! Something went wrong");
          })
          .catch((error) => {
            this.$toasted.show("Catch Error", error);
          });
      },
      CheckLogin: function() {
        this.submitted = true;
        let loader = this.$loading.show();
        this.$validator.validate().then((valid) => {
          if (true) {
            let payload = {
              booking_id: this.booking_id,
              username: this.username,
              password: this.password,
              noCheck: true,
            };
            PosService.CheckCinemaManagerLogin(payload)
              .then((response) => {
                const { data } = response;
                this.username = "";
                this.password = "";
                if (data.status) {
                  const {cine_id, cinema_name} = data.bookingDetails
                  if(this.validateCinemaSpecificRefund(cine_id)) {
                  this.$refs.cinemaManagerLoginPopup.hide();
                  this.section.one = false;
                  this.section.two = true;
                  this.card_trx_details = data.Records[0].card_trx_details;
                  this.card_payment_gateway =
                    data.Records[0].card_payment_gateway;
                  this.seats = data.Records;
                  this.Selectedseats = data.Records;
                  this.seatsArr = [
                    {
                      label: "All",
                      SeatsArray: data.Records,
                    },
                  ];
                  this.isPrivateShow =
                    data.Records.length > 0 &&
                    data.Records[0].mycinema_booking_type_id &&
                    data.Records[0].mycinema_booking_type_id == 3
                      ? true
                      : false;
                  let OfferDetails = data.offerDetails;
                  this.BookingDetails = data.bookingDetails;
                  if (
                    data.bookingDetails.hasOwnProperty("fnb_items") &&
                    data.bookingDetails.fnb_items.length > 0
                  ) {
                    this.FnbItemArray = data.bookingDetails.fnb_items.filter(
                      (x) => x.is_refund == "N"
                    );
                    if (this.FnbItemArray && this.FnbItemArray.length > 0) {
                      this.FnbItemArray.forEach((fi) => {
                        fi["reload_stock"] = "N";
                        if (fi.hasOwnProperty("combo_data") && fi.combo_data) {
                          fi["combo_data"] = fi.combo_data
                            ? JSON.parse(fi.combo_data)
                            : [];
                          if (fi.combo_data.length > 0) {
                            fi.combo_data.map((c) => {
                              c["reload_stock"] = "N";
                            });
                          }
                        }
                      });
                    }
                    this.FnbRefundAmount = data.bookingDetails.fnb_items.reduce(
                      (acc, { total_price }) => acc + parseFloat(total_price)
                    );
                    this.order_code = data.bookingDetails.hasOwnProperty(
                      "order_code"
                    )
                      ? data.bookingDetails.order_code
                      : null;
                  }
                  console.log("FnbRefundAmount >> /?", this.FnbRefundAmount);
                  if (
                    data.bookingDetails.hasOwnProperty(
                      "onlinePaymentModeDetails"
                    )
                  ) {
                    this.online_pm_details =
                      data.bookingDetails.onlinePaymentModeDetails || "";
                  }
                  this.offer_name = OfferDetails.offer_name;
                  this.offer_price = OfferDetails.offer_price.toFixed(2);
                  this.voucher_name = OfferDetails.voucher_name;
                  this.refund = {
                    booking_id: this.booking_id,
                    ...this.refund,
                    ...data.Records[0],
                  };
                  this.refund["curr_code"] =
                    data.bookingDetails["currency_code"] || "";
                  } else {
                    this.$toasted.show(`Refund for this Booking can be avail at ${cinema_name} Branch.`);
                  }
                } else {
                  this.$refs.cinemaManagerLoginPopup.hide();
                  this.$toasted.show(
                    data.message ||
                      "Sorry! Something went wrong. kindly contact your administrator"
                  );
                }
              })
              .finally(() => {
                loader.hide();
              });
          }
        });
      },
      getCinemaTicketTemplate: function() {
        const { cinema_id } = this.secureStore.get("USINFO");
        let body = {
          cine_id: cinema_id,
        };
        MasterService.TicketTemplateByCinemaID(body).then((response) => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.TemplateList = data.Records;
            }
          }
        });
      },
      getBookingInfoForTicket() {
        const { cinema_id, username, cine_name } = this.secureStore.get(
          "USINFO"
        );
        let arabic_company_name = "";

        let arabic_company_name_data = JSON.parse(
          this.BookingDetails.cinema_translation_data
        ).filter((lang) => {
          return lang.langaugeId == 3;
        });

        if (
          arabic_company_name_data &&
          arabic_company_name_data.length > 0 &&
          arabic_company_name_data[0].hasOwnProperty("company_name")
        ) {
          arabic_company_name = arabic_company_name_data[0].company_name;
        }

        let tempObj = {
          template_id: this.TemplateList[0].template_id,
          pos_user_name: username,
          translationData: arabic_company_name,
          cine_name: this.BookingDetails.cinema_name,
          cine_address: this.BookingDetails.cinema_address,
          company_name: this.BookingDetails.company_name,
          vat_number: this.BookingDetails.vat_number,
          sb_id: this.BookingDetails.show_booking_id,
          sb_booking_code: this.BookingDetails.sb_booking_code,
          og_show_date: this.BookingDetails.t_show_date_full,
          og_show_time: this.BookingDetails.t_show_time,
          sb_booking_date: this.BookingDetails.sb_booking_date_time,
          sb_booking_time: this.BookingDetails.sb_booking_date_time,
        };

        return tempObj;
      },
      sleep(n) {
        return new Promise((resolve) => setTimeout(resolve, n));
      },
      async printBO() {
        this.$socket.emit("on_print_ticket", {
          showBookingId: this.BookingDetails["show_booking_id"],
          cinema_id: this.secureStore.get("USINFO").cinema_id,
          baseurl: BASEURL,
          isReprint: false,
          isRefund: true,
          ttype: "refund-invoice",
        });
        return await this.sleep(300);
      },
      async printBOAddon(addOnsArr = []) {
        if (addOnsArr.length > 0) {
          let overallPrice = 0;
          let bookingInfo = this.getBookingInfoForTicket();
          addOnsArr.map((z, index) => {
            overallPrice += z.final_price;
            this.$socket.emit("on_print_ticket", {
              addOns: JSON.stringify(z),
              bookingDetails: JSON.stringify(bookingInfo),
              ttype: "addon-ticket",
              isReprint: false,
              baseurl: BASEURL,
              isRefund: true,
            });
          });

          return await this.sleep(600);
        } else {
          return await this.sleep(1);
        }
      },
      async printBOSecurity(addOnsArr = [], overallPrice = 0) {
        this.$socket.emit("on_print_ticket", {
          showBookingId: this.BookingDetails.show_booking_id,
          cinema_id: this.secureStore.get("USINFO").cinema_id,
          overallPrice: overallPrice,
          baseurl: BASEURL,
          ttype: "security-ticket",
          addOnsArr: JSON.stringify(addOnsArr),
          isReprint: false,
          isRefund: true,
        });
        return await this.sleep(1200);
      },
      async printFnB() {
        if (
          (this.order_code && this.onlineMode) ||
          (this.allow_fnb_refund == "Y" &&
            this.FnbItemArray.length > 0 &&
            this.order_code)
        ) {
          this.$socket.emit("on_print_ticket", {
            baseurl: BASEURL,
            ttype: "fnb-refund",
            OrderCode: this.order_code,
            Type: "Print",
            UserID: this.secureStore.get("USINFO").user_id,
            isReprint: this.isReprint,
            isRefund: true,
          });
          return await this.sleep(1700);
        } else {
          return await this.sleep(1);
        }
      },
      async printFnBSecurity() {
        if (
          (this.order_code && this.onlineMode) ||
          (this.allow_fnb_refund == "Y" &&
            this.FnbItemArray.length > 0 &&
            this.order_code)
        ) {
          this.$socket.emit("on_print_ticket", {
            baseurl: BASEURL,
            ttype: "fnb-security",
            OrderCode: this.order_code,
            UserID: this.secureStore.get("USINFO").user_id,
            cinemaId: this.secureStore.get("USINFO").cinema_id,
            isReprint: false,
            extra_query_obj: {
              isRefund: true,
            },
          });
          return await this.sleep(2000);
        } else {
          return await this.sleep(1);
        }
      },
      onPrintHandler: async function(isReprint = false) {
        const {
          cinema_id,
          username,
          cine_name,
          user_id,
        } = this.secureStore.get("USINFO");
        let addOnsArr = [];
        let overallPrice = 0;
        let isRefund = true;
        this.BookingDetails.final_addon_gross_charges.map((x) => {
          if (x.length > 0) {
            x.forEach((y) => {
              if (y.is_additional_price_on_ticket == "N") {
                addOnsArr.push(y);
              }
            });
          }
        });
        // console.log("addOnsArr", addOnsArr);
        if (addOnsArr.length > 0) {
          overallPrice = addOnsArr.reduce(
            (acc, { final_price }) => acc + parseFloat(final_price)
          );
        }
        var userAgent = navigator.userAgent.toLowerCase();
        let bookingInfo = this.getBookingInfoForTicket();
        if (userAgent.indexOf(" electron/") > -1) {
          try {
            if (this.$socket) {
              if (this.checkPrintAvailable) {
                this.printBO()
                  .then(() => {
                    console.log("in here at bo");
                    return this.printBOAddon(addOnsArr);
                  })
                  .then(() => {
                    console.log("in here at bo security");
                    return this.printBOSecurity(addOnsArr, overallPrice);
                  })
                  .then(() => {
                    console.log("in here at fnb");
                    return this.printFnB();
                  })
                  .then(() => {
                    console.log("in here at fnb security");
                    return this.printFnBSecurity();
                  });
              } else {
                console.log("IN ELSE this.TemplateList[0].refund_temp_name");
              }
            } else {
              console.log("NO SOCKET");
            }
          } catch (err) {
            console.log("ERROR:", err);
          }
        } else {
          if (this.checkPrintAvailable) {
            console.log("template", this.TemplateList[0].template_id);
            PosService.GetRefundTicketEjs(
              this.BookingDetails["show_booking_id"],
              cinema_id,
              isReprint
            )
              .then((response) => {
                if (response) {
                  const { data } = response;
                  this.EjsData = data;
                  this.$nextTick(() => {
                    const p = new Printd();
                    if (this.$refs.onPrint && this.EjsData != null) {
                      p.print(this.$refs.onPrint, []);
                    }
                  });
                }
              })
              .then(() => {
                addOnsArr.map((z, index) => {
                  overallPrice += z.final_price;
                  setTimeout(() => {
                    let payload = {
                      addOns: JSON.stringify(z),
                      bookingDetails: JSON.stringify(bookingInfo),
                      isReprint: false,
                      isRefund: isRefund,
                    };
                    PosService.GetAddonTicketEjs(payload).then(
                      async (s_response) => {
                        const { data } = s_response;

                        this.EjsData = data;

                        this.$nextTick(() => {
                          const p = new Printd();
                          if (this.$refs.onPrint && this.EjsData != null) {
                            p.print(this.$refs.onPrint, []);
                          }
                        });
                      }
                    );
                  }, 2000);
                });
              })
              .then(() => {
                PosService.GetTicketSecurityEjs(
                  this.BookingDetails["show_booking_id"],
                  cinema_id,
                  isReprint,
                  addOnsArr,
                  isRefund
                ).then(async (s_response) => {
                  const { data } = s_response;

                  this.EjsData = data;

                  this.$nextTick(() => {
                    const p = new Printd();
                    if (this.$refs.onPrint && this.EjsData != null) {
                      p.print(this.$refs.onPrint, []);
                    }
                  });
                });
              })
              .then(() => {
                if (
                  (this.order_code && this.onlineMode) ||
                  (this.allow_fnb_refund == "Y" &&
                    this.FnbItemArray.length > 0 &&
                    this.order_code)
                ) {
                  let payload = {
                    OrderCode: this.order_code,
                    Type: "Print",
                    UserID: user_id,
                    isReprint: this.isReprint,
                    isRefund: true,
                  };
                  PosFnbService.GetFnbRefundEjs(payload)
                    .then(async (response) => {
                      const { data } = response;
                      this.EjsData = data;
                      this.$nextTick(() => {
                        const p = new Printd();
                        if (this.$refs.onPrint && this.EjsData != null) {
                          p.print(this.$refs.onPrint, []);
                        }
                      });
                    })
                    .catch(this._CatchError);
                }
              })
              .catch(this._CatchError);
          } else {
            console.log("No template selected for Refund Invoice");
          }
        }
      },
    },
  };
</script>
<style>
  .invalid_input {
    border: 1px solid red !important;
  }

  .content-fnb-refund {
    height: 500px;
    overflow: auto;
    padding-top: 20px;
  }

  .pos_refund_fullscreen {
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    z-index: 999 !important;
    height: 100% !important;
    padding: 16px !important;
    position: fixed !important;
    background-color: #fff !important;
    overflow-y: auto !important;
  }

  .disableRefundBtn {
    opacity: 0.5;
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Partials/posRefund.vue